import React from 'react';

const listContext = React.createContext();

export { listContext };